export default {
  namespace: true,
  state: {

  },
  getters: {
    getActivePageName: (state, getters, rootState) => rootState.route.name,
    isDashboard: (state, getters) => getters.getActivePageName === 'DataDashboard',
    isAbout: (state, getters) => getters.getActivePageName === 'About',
    isResource: (state, getters) => getters.getActivePageName === 'Resources',
    isActionPlan: (state, getters) => getters.getActivePageName === 'ActionPlan',
    isInsights: (state, getters) => getters.getActivePageName === 'Insights',

  },
  mutations: {

  },
  actions: {

  },
};
